export const EmailIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width='17'
      height='13'
      viewBox='0 0 17 13'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 1.88525V1.80469H0.00322266C0.0418945 0.802441 0.870117 0 1.88525 0H14.6147C15.6299 0 16.4549 0.802441 16.4968 1.80469H16.5V10.3125C16.5 11.4501 15.5751 12.375 14.4375 12.375H2.0625C0.924902 12.375 0 11.4501 0 10.3125V1.88525ZM15.4688 3.59648L9.77432 7.76982C8.86553 8.43369 7.63125 8.43369 6.72568 7.76982L1.03125 3.59648V10.3125C1.03125 10.8829 1.49209 11.3438 2.0625 11.3438H14.4375C15.0079 11.3438 15.4688 10.8829 15.4688 10.3125V3.59648ZM15.4688 1.88525C15.4688 1.41475 15.0853 1.03125 14.6147 1.03125H1.88525C1.41475 1.03125 1.03125 1.41475 1.03125 1.88525C1.03125 2.15596 1.16016 2.41377 1.3793 2.5749L7.33477 6.93838C7.87939 7.33799 8.62061 7.33799 9.16523 6.93838L15.1207 2.57168C15.3398 2.41055 15.4688 2.15596 15.4688 1.88203V1.88525Z'
        fill='#262627'
      />
    </svg>
  )
}
